import {
  SerializedError,
  createSlice,
  isRejectedWithValue,
} from "@reduxjs/toolkit";
import { ToastUtil } from "../../utils/ToastUtil";
import * as CategoryActions from './categories.actions';
import { ICategoryResponseView } from "../../modules/categories/models/ICategoryResponseView";
import { ICategoryRequestView } from "../../modules/categories/models/ICategoryRequestView";

export const categoryFeatureKey = "categoryFeature";

export interface InitialState {
  loading: boolean;
  error: SerializedError;
  categories: ICategoryResponseView[];
  category: ICategoryResponseView;
}

const initialState: InitialState = {
  loading: false,
  error: {} as SerializedError,
  categories: [] as ICategoryRequestView[],
  category: {} as ICategoryResponseView,
};

export const categorySlice = createSlice({
  name: "categorySlice",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    
    // Create a Category
    builder
      .addCase(CategoryActions.createCategoryAction.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(CategoryActions.createCategoryAction.fulfilled, (state, action) => {
        state.loading = false;
        state.category = action.payload.data;
        ToastUtil.displaySuccessToast(action.payload.msg);
      })
      .addCase(CategoryActions.createCategoryAction.rejected, (state, action) => {
        state.loading = false;
        ToastUtil.displayErrorToast(action.payload.msg);
        if (isRejectedWithValue(action)) {
          state.error = action.error;
        }
      });

    // Create a Sub Category
    builder
      .addCase(CategoryActions.createSubCategoryAction.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(CategoryActions.createSubCategoryAction.fulfilled, (state, action) => {
        state.loading = false;
        state.category = action.payload.data;
        ToastUtil.displaySuccessToast(action.payload.msg);
      })
      .addCase(CategoryActions.createSubCategoryAction.rejected, (state, action) => {
        state.loading = false;
        ToastUtil.displayErrorToast(action.payload.msg);
        if (isRejectedWithValue(action)) {
          state.error = action.error;
        }
      });

    // Get All Categories
    builder
      .addCase(CategoryActions.getAllCategoriesAction.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(CategoryActions.getAllCategoriesAction.fulfilled, (state, action) => {
        state.loading = false;
        state.categories = action.payload.data;
      })
      .addCase(CategoryActions.getAllCategoriesAction.rejected, (state, action) => {
        state.loading = false;
        ToastUtil.displayErrorToast('Getting All Categories Failed!');
        if (isRejectedWithValue(action)) {
          state.error = action.error;
        }
      });
  },
});
